import { ShieldCheck, Clock, CalendarCheck, UserCheck } from "lucide-react";

export default function TrustBanner() {
  const points = [
    {
      icon: Clock,
      title: "Poupa horas por semana",
      desc: "Sem responder às mesmas perguntas repetidas. A Automia trata disso por si, em Português de Portugal, 24h por dia.",
    },
    {
      icon: CalendarCheck,
      title: "Mais marcações, menos falhas",
      desc: "A agenda preenche-se automaticamente sem trocas de emails nem chamadas perdidas.",
    },
    {
      icon: UserCheck,
      title: "O controlo fica sempre consigo",
      desc: "Quando a IA não tem certeza, pausa e notifica-o. Nenhuma decisão importante é tomada sem si.",
    },
  ];

  return (
    <section
      id="seguranca"
      data-testid="trust-banner"
      className="relative py-16 sm:py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-500/40 to-transparent" />
      <div className="absolute inset-0 radial-glow opacity-50" aria-hidden />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass-card text-[11px] font-semibold uppercase tracking-[0.2em] text-cyan-300">
            <ShieldCheck className="h-3.5 w-3.5" />
            Confiança & Segurança
          </div>
          <h2
            data-testid="trust-title"
            className="mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter text-white leading-[1.05]"
          >
            Inteligência que trabalha<br />
            <span className="text-gradient-blue">para si. Sempre.</span>
          </h2>
          <p className="mt-5 sm:mt-6 text-base sm:text-lg text-slate-400 max-w-2xl font-light leading-relaxed">
            Enquanto trata dos seus clientes, a Automia está a responder mensagens em Português de Portugal, a marcar consultas e a poupar-lhe horas de trabalho, todos os dias, incluindo fins de semana.
          </p>
        </div>

        <div className="mt-12 sm:mt-16 grid md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {points.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`trust-point-${i}`}
                className="glass-card rounded-2xl p-7 hover:border-blue-500/30 transition-colors group"
              >
                <div className="h-11 w-11 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center mb-5 group-hover:bg-blue-500/20 transition">
                  <Icon className="h-5 w-5 text-blue-300" strokeWidth={1.8} />
                </div>
                <h3 className="text-xl font-medium text-white tracking-tight">{p.title}</h3>
                <p className="mt-3 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
